module.exports = __webpack_public_path__ + "img/visa.b7d8fbbd.png";